import Spinner from 'legacy/app/components/help/Spinner';
import useStartPaymentProcessorSession from 'legacy/lib/api/hooks/useStartPaymentProcessorSession';
import { PaymentSessionType } from 'legacy/lib/api/types/PaymentSessionType';
import React from 'react';

const PaymentsReport = (): JSX.Element | null => {
	const {
		data: sessionInfo,
		isLoading,
		error,
	} = useStartPaymentProcessorSession(PaymentSessionType.PAYMENTREPORT);

	if (isLoading) {
		return <Spinner isChild />;
	}

	if (error) {
		return null;
	}

	return (
		<rainforest-payment-report
			show-export-button
			columns={JSON.stringify([
				{ name: 'Created', type: 'builtin', value: 'created' },
				{
					name: 'Exp. Deposit',
					type: 'builtin',
					value: 'expected_deposit_date',
				},
				{ name: 'Type', type: 'builtin', value: 'type' },
				{ name: 'Status', type: 'builtin', value: 'status' },
				{ name: 'Amount', type: 'builtin', value: 'amount' },
				{ name: 'Customer', type: 'builtin', value: 'name' },
				{ name: 'Method', type: 'builtin', value: 'method' },
				{ name: 'Merchant Name', type: 'builtin', value: 'merchant_name' },
			])}
			data-filters={JSON.stringify({
				merchant_id: sessionInfo?.merchantId,
			})}
			session-key={sessionInfo?.sessionKey}
		/>
	);
};

PaymentsReport.displayName = 'PaymentsReport';

export default PaymentsReport;
